/* eslint-disable prettier/prettier */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import VoiceOverOffIcon from '@material-ui/icons/VoiceOverOff'
import { IconButton } from '@material-ui/core'
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver'
import Tooltip from '@material-ui/core/Tooltip'
import React from 'react'

export default function muteAllButton({ handleMuteAll, areAllMuted, classes }) {
  const title = areAllMuted ? 'Ativar Microfones' : 'Desativar Microfones'
  return (
    <Tooltip title={title} aria-label="add">
      <IconButton
        edge="start"
        color="inherit"
        aria-label="videoCamera"
        onClick={handleMuteAll}
        className={classes.toolbarButtons}
      >
        {areAllMuted ? (
          <RecordVoiceOverIcon fontSize="inherit" />
        ) : (
          <VoiceOverOffIcon fontSize="inherit" />
        )}
      </IconButton>
    </Tooltip>
  )
}